import $ from 'jquery';

const getFlagEmoji = (countryCode) => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

const countryFlagsRegex = /^((?![\p{Regional_Indicator}]).)*$/u;

window.addEventListener('message', (event) => {
  if (
    event.data.type === 'hsFormCallback' &&
    event.data.eventName === 'onFormReady'
  ) {
    let heroFormCountryPhoneFieldOption = $('.hs-fieldtype-intl-phone option');
    heroFormCountryPhoneFieldOption.each(function () {
      let heroFormCountryPhoneFieldOptionVal = $(this).val();
      let heroFormCountryPhoneFieldOptionText = $(this).text();

      if (countryFlagsRegex.test(heroFormCountryPhoneFieldOptionText)) {
        $(this).text(
          getFlagEmoji(heroFormCountryPhoneFieldOptionVal) +
            ' ' +
            heroFormCountryPhoneFieldOptionText
        );
      }
    });
  }
});
